import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';
  // @ts-ignore
  import { BDropdown } from 'buefy/dist/esm/dropdown';
  import { Button } from '@/ui/components/Button';
  import { t } from '@/ui/i18n/i18n';
  import { parseConfidenceValue, useConfidenceRangeValidation } from './useConfidenceRangeValidation';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfidenceRangeFilter',
  props: {
    min: {
      type: String,
      required: true,
    },
    max: {
      type: String,
      required: true,
    },
    minError: {
      type: [String, null],
      default: null,
    },
    maxError: {
      type: [String, null],
      default: null,
    },
  },
  emits: ['update:min', 'update:max'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const dropdown = ref<BDropdown | null>(null);
  const isActive = ref(false);
  const localMin = ref(props.min);
  const localMax = ref(props.max);

  watch(() => props.min, value => {
    localMin.value = value;
  });

  watch(() => props.max, value => {
    localMax.value = value;
  });

  const parsedMin = computed(() => parseConfidenceValue(localMin.value));
  const parsedMax = computed(() => parseConfidenceValue(localMax.value));

  const { minError, maxError, hasValidationErrors } = useConfidenceRangeValidation(
    parsedMin,
    parsedMax,
    {
      externalMinError: computed(() => props.minError),
      externalMaxError: computed(() => props.maxError),
    },
  );
  const hasItemSelected = computed(() => !!props.min || !!props.max);

  const icon = computed(() => isActive.value ? 'angle-up' : 'angle-down');

  const triggerText = computed(() => {
    if (props.min && props.max) {
      return `${props.min}% – ${props.max}%`;
    }
    return t('ai-photo-validation.confidence');
  });

  const onActiveChange = (active: boolean) => {
    isActive.value = active;
    if (active) {
      localMin.value = props.min;
      localMax.value = props.max;
    }
  };

  const onCancel = () => {
    localMin.value = props.min;
    localMax.value = props.max;
    dropdown.value?.toggle();
  };

  const onApply = () => {
    if (!hasValidationErrors.value) {
      emit('update:min', localMin.value);
      emit('update:max', localMax.value);
      dropdown.value?.toggle();
    }
  };

return { __sfc: true,props, emit, dropdown, isActive, localMin, localMax, parsedMin, parsedMax, minError, maxError, hasValidationErrors, hasItemSelected, icon, triggerText, onActiveChange, onCancel, onApply, BDropdown, Button }
}

})